// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UseShouldShowPropertyDetails_propertyV5_graphql = require("../../../__generated__/UseShouldShowPropertyDetails_propertyV5_graphql.bs.js");

let convertFragment = UseShouldShowPropertyDetails_propertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, UseShouldShowPropertyDetails_propertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(UseShouldShowPropertyDetails_propertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UseShouldShowPropertyDetails_propertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(UseShouldShowPropertyDetails_propertyV5_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function use$1(property) {
  let property$1 = RescriptRelay_Fragment.useFragment(UseShouldShowPropertyDetails_propertyV5_graphql.node, convertFragment, property);
  let tmp;
  switch (property$1.__typename) {
    case "ForSalePropertyV5" :
      let match = property$1.agentV2Id;
      if (match !== undefined && match.__typename === "VisibleForSalePropertyAgent") {
        let match$1 = match.agent;
        tmp = match$1 !== undefined ? match$1.id : undefined;
      } else {
        tmp = undefined;
      }
      break;
    case "RentalPropertyV5" :
      let match$2 = property$1.agentId;
      tmp = match$2 !== undefined ? match$2.id : undefined;
      break;
    case "__unselected" :
      tmp = undefined;
      break;
  }
  return UserSession.useShouldShowPropertyDetails(tmp);
}

exports.PropertyFragment = PropertyFragment;
exports.use = use$1;
/* UserSession Not a pure module */
